import { createContext } from 'react';

const topBarMenuButtonStateContext = {
  isOpen: false,
};

export const TopBarMenuButtonStateContext = createContext(topBarMenuButtonStateContext);
